import React, { Component } from 'react';
import PropTypes from 'prop-types';
// Redux
import { flowRight as compose } from 'lodash';
import { Field, reduxForm, reset } from 'redux-form';
import validate from './validate';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
// Translation
import { FormattedMessage, injectIntl } from 'react-intl';
// Component
import AdminStarRating from '../AdminStarRating';
import CommonFormComponent from '../../CommonField/CommonFormComponent';
import Link from '../../Link';
// GraphQL
import WriteAdminReviewMutation from './WriteAdminReviewMutation.graphql';
import history from '../../../core/history';
import showToaster from '../../../helpers/toasterMessages/showToaster';
import { withMutation } from '../../../hoc/withGraphql';
import { demoRestriction } from '../../../helpers/DemoRestriction/demoRestriction';

//Image
import { GoBackArrow } from '../../Common/Assets/SvgIconComponent/CommonSvgIcon';

import cs from '../../../components/commonStyle.css';
import s from './AdminReviewsForm.css';
import messages from '../../../locale/jsonMessages';

class AdminReviewsForm extends Component {

  static propTypes = {
    title: PropTypes.string.isRequired,
    initialValues: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.submitForm = this.submitForm.bind(this);
  }


  renderStarRating = ({ input, label, meta: { touched, error }, className, children }, value) => {
    const { formatMessage } = this.props.intl;
    return (
      <div >
        <label className='commonLabelText' >{label}</label>
        <AdminStarRating
          name={input.name}
          change={input.onChange}
          value={input.value}
          editing={true}
          className={s.reviewsFormStar}
        />
        {touched && error && <span className={s.errorMessage}>{formatMessage(error)}</span>}
      </div>

    )
  }

  async submitForm(values, dispatch) {
    const { mutate, demoRestriction } = this.props;
    const isRestrict = await demoRestriction({});
    if (isRestrict) return;
    const { data } = await mutate({
      variables: {
        id: values?.id,
        listId: Number(values?.listId),
        reviewContent: values?.reviewContent,
        rating: values?.rating
      }
    });
    if (data?.writeAdminReview) {
      if (data?.writeAdminReview?.status === '200') {
        if (values.id) {
          showToaster({ messageId: 'updateAdminReview', toasterType: 'success' })
        } else {
          showToaster({ messageId: 'submitAdminReview', toasterType: 'success' })
          dispatch(reset('AdminReviewsForm'));
        }
      } else if (data?.writeAdminReview?.status === '404') {
        showToaster({ messageId: 'listIdNotAvailable', toasterType: 'error' })
      } else {
        showToaster({ messageId: 'adminReviewFailed', toasterType: 'error' })
      }
      history.push('/siteadmin/reviews')
    }
  }

  render() {
    const { error, handleSubmit, submitting, title, initialValues } = this.props;
    const { formatMessage } = this.props.intl;

    return (
      <div className='siteAdminCenterContainer'>
        {initialValues &&
          <div className={cx('singleBtnFlexEnd', cs.spaceBottom4)}>
            <Link to={'/siteadmin/reviews'} className='goBackLink'>
              <GoBackArrow />
              <FormattedMessage  {...messages.goBack} />
            </Link>
          </div>
        }
        <div className='siteAdminCenterContainerBox'>
          <h1 className='siteAdminHeading'> {initialValues ? <FormattedMessage  {...messages.editReviews} /> : <FormattedMessage  {...messages.writeReviews} />} </h1>
          <form onSubmit={handleSubmit(this.submitForm)}>
            {error && <strong>{formatMessage(error)}</strong>}
            <div className="oneColumnGrid">
              <Field name="listId"
                type="text"
                component={CommonFormComponent}
                placeholder={formatMessage(messages.carIDText)}
                labelText={formatMessage(messages.carIDText)}
                inputClass='commonInputField'
                isRequiredInput
              />

              <Field name="reviewContent"
                component={CommonFormComponent}
                componentClass={'textarea'}
                inputClass='commonTextAreaField'
                labelText={formatMessage(messages.reviewContentLabel)}
                placeholder={formatMessage(messages.reviewContentLabel)}
                isRequiredInput
              />

              <Field name="rating"
                component={this.renderStarRating}
                label={formatMessage(messages.reviewRating)} />
            </div>
            <div className={cx(cs.spaceTop4, 'singleBtnFlexEnd')}>
              <Button className={cx(cs.btnPrimary)} type="submit" disabled={submitting}><FormattedMessage  {...messages.submit} /></Button>
            </div>
          </form>
        </div>
      </div>
    );
  }

}

AdminReviewsForm = reduxForm({
  form: 'AdminReviewsForm', // a unique name for this form
  validate
})(AdminReviewsForm);

const mapState = (state) => ({});

const mapDispatch = {
  demoRestriction
};

export default compose(injectIntl,
  withStyles(cs, s),
  connect(mapState, mapDispatch),
  withMutation(WriteAdminReviewMutation)
)(AdminReviewsForm);
